import React from "react";
import {
  Grid,
  FormControl,
  InputLabel,
  OutlinedInput,
  FormHelperText,
  InputAdornment,
  ListItemText,
  Checkbox,
} from "@mui/material";
import { useFormContext } from "react-hook-form";
import CustomSelect from "../../../../Components/CustomSelect";
import PercentIcon from "@mui/icons-material/Percent";

const Step6_OtherConfig = ({
  notificationFreqOptions,
  priorityRuleOptions,
  yesNoOptions,
  renderPriorityRuleOption,
}) => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
  } = useFormContext();

  const loan_agent = watch("loan_agent");
  const top_up = watch("top_up");
  const loan_colleteral = watch("loan_colleteral");
  const priority_rule = watch("priority_rule") || [];

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="notification_freq"
          id="notification_freq"
          value={watch("notification_freq") || ""}
          label="Notification frequency"
          onChange={(e) => setValue("notification_freq", e.target.value)}
          options={notificationFreqOptions}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="loan_agent"
          id="loan_agent"
          value={loan_agent || ""}
          label="Loan agent"
          onChange={(e) => setValue("loan_agent", e.target.value)}
          options={yesNoOptions}
        />
      </Grid>

      {loan_agent === "YES" && (
        <>
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.agent_commission_p}>
              <InputLabel htmlFor="agent_commission_p">
                Agent commission fee percentage
              </InputLabel>
              <OutlinedInput
                id="agent_commission_p"
                type="number"
                {...register("agent_commission_p")}
                label="Agent commission fee percentage"
                onWheel={(event) => event.target.blur()}
                inputProps={{ step: "any", min: 0 }}
                endAdornment={
                  <InputAdornment position="end">
                    <PercentIcon />
                  </InputAdornment>
                }
                fullWidth
                defaultValue="0"
              />
              {errors.agent_commission_p && (
                <FormHelperText>Enter agent commission</FormHelperText>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={3}>
            <FormControl fullWidth error={!!errors.rev_commission_p}>
              <InputLabel htmlFor="rev_commission_p">
                Rev commission percentage
              </InputLabel>
              <OutlinedInput
                id="rev_commission_p"
                type="number"
                {...register("rev_commission_p")}
                label="Rev commission percentage"
                onWheel={(event) => event.target.blur()}
                defaultValue=""
                fullWidth
                inputProps={{ step: "any", min: 0 }}
                endAdornment={
                  <InputAdornment position="end">
                    <PercentIcon />
                  </InputAdornment>
                }
              />
              {errors.rev_commission_p && (
                <FormHelperText>
                  Enter revenue commission percentage
                </FormHelperText>
              )}
            </FormControl>
          </Grid>
        </>
      )}

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="top_up"
          id="top_up"
          value={top_up || ""}
          label="Top up"
          onChange={(e) => setValue("top_up", e.target.value)}
          options={yesNoOptions}
        />
      </Grid>

      {top_up === "YES" && (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth error={!!errors.top_up_p}>
            <InputLabel htmlFor="top_up_p">Top up percentage</InputLabel>
            <OutlinedInput
              id="top_up_p"
              type="number"
              {...register("top_up_p")}
              label="Top up percentage"
              onWheel={(event) => event.target.blur()}
              inputProps={{ step: "any", min: 0 }}
              fullWidth
              defaultValue="0"
              endAdornment={
                <InputAdornment position="end">
                  <PercentIcon />
                </InputAdornment>
              }
            />
            {errors.top_up_p && (
              <FormHelperText>Enter top up percentage</FormHelperText>
            )}
          </FormControl>
        </Grid>
      )}

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="loan_colleteral"
          id="loan_colleteral"
          value={loan_colleteral || ""}
          label="Loan Collateral"
          onChange={(e) => setValue("loan_colleteral", e.target.value)}
          options={yesNoOptions}
        />
      </Grid>

      {loan_colleteral === "YES" && (
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <FormControl fullWidth error={!!errors.collecteral_types}>
            <InputLabel htmlFor="collecteral_types">Collateral type</InputLabel>
            <OutlinedInput
              id="collecteral_types"
              type="text"
              {...register("collecteral_types")}
              label="Collateral type"
              fullWidth
            />
            {errors.collecteral_types && (
              <FormHelperText>Enter collateral type</FormHelperText>
            )}
          </FormControl>
        </Grid>
      )}

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <FormControl fullWidth error={!!errors.other_charges}>
          <InputLabel htmlFor="other_charges">Other charges</InputLabel>
          <OutlinedInput
            id="other_charges"
            type="number"
            {...register("other_charges")}
            label="Other charges"
            fullWidth
            onWheel={(event) => event.target.blur()}
            inputProps={{ step: "any", min: 0 }}
          />
          {errors.other_charges && (
            <FormHelperText>Enter other charges</FormHelperText>
          )}
        </FormControl>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="loan_approval"
          id="loan_approval"
          value={watch("loan_approval") || ""}
          label="Loan Approval"
          onChange={(e) => setValue("loan_approval", e.target.value)}
          options={[
            { value: "engine", label: "Engine" },
            { value: "manual", label: "Manual" },
          ]}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <CustomSelect
          labelId="priority_rule"
          id="priority_rule"
          multiple
          value={priority_rule}
          onChange={(e) => {
            const {
              target: { value },
            } = e;
            setValue(
              "priority_rule",
              typeof value === "string" ? value.split(",") : value
            );
          }}
          input={<OutlinedInput label="Priority rule" />}
          options={priorityRuleOptions}
          renderOption={renderPriorityRuleOption}
          label="Priority rule"
        />
      </Grid>
    </Grid>
  );
};

export default Step6_OtherConfig;
